import { ICourse } from '@/models/ICourse';
import css from 'styled-jsx/css';
import React from 'react';
import moduleStyles from './study-program-card.module.scss';

type Props = {
  studyProgram: ICourse;
  brandColor: string;
};

function getStyles(uniBackgroundColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .card::before {
      background-color: ${uniBackgroundColor};
    }
  `;
}

export default function StudyProgramCard({ studyProgram, brandColor }: Props) {
  const { className, styles } = getStyles(brandColor);

  return (
    <>
      {styles}
      <div
        className={`${moduleStyles.program_card} ${className} rounded-border-6 bg-white element-default-style card align-items-center flex-row`}
      >
        <h3 className="m-0 font-family-lato">{studyProgram.mainProgram.name}</h3>
      </div>
    </>
  );
}
